import { Form, ListItem } from '@domain-group/suit-theme'

import usePortal from '@hooks/usePortal'
import usePortalOptions from '@hooks/usePortalOptions'

import { AgencyPortalModel } from '@models/types'

import PortalOptions from '../PortalOptions'

interface PortalProps {
  agencyPortal: AgencyPortalModel,
  disabled?: boolean,
  selectedAgencyId: number,
}

const Portal = (props: PortalProps) => {
  const {
    agencyPortal, disabled, selectedAgencyId,
  } = props

  const { portal, portal: { title } } = usePortal({ id: agencyPortal.portal_id })

  const { filteredPortalOptions } = usePortalOptions({
    filters: {
      // @ts-expect-error TS2339
      portal_id: portal?.id,
    },
  })

  if (!filteredPortalOptions.length) return null

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{ borderBottom: '1px dashed', padding: 'large', paddingBottom: 'medium' }}
      disableHover
    >
      <Form.Field label={title}>
        {filteredPortalOptions.map(portalOption => (
          <PortalOptions
            key={portalOption.id}
            // @ts-expect-error TS2322
            portal={portal}
            // @ts-expect-error TS2322
            disabled={disabled}
            portalOption={portalOption}
            selectedAgencyId={selectedAgencyId}
          />
        ))}
      </Form.Field>
    </ListItem>
  )
}

export default Portal
